import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'antd'
import useDebouncedFunction from 'utils/hooks/useDebouncedFunction'

import ConditionSelect from 'components/ConditionSelect'
import CareChoiceSelect from 'components/CareChoiceSelect'

import Ticket from 'model/tickets/ticket'
import { Label } from 'pages/Ticket/styled'
import { Button } from 'ui/styled'
import clear_triage from 'assets/clear_triage.png'
import { parseSymptom } from 'pages/Ticket/helpers'
import useMedicalNavigationUpdate from 'apollo/mutations/MEDICAL_NAVIGATION_UPDATE'
import { FormItem } from './styled'

const MedicalNavigationFields = ({
  ticket,
  toggleTriage = () => {},
  shouldHighlight
}) => {
  const isClosed = ticket?.state?.isClosed
  const isInProgress = ticket?.state?.isInProgress
  const TicketId = ticket?.resource?.id

  const { onMedicalNavigationUpdate } = useMedicalNavigationUpdate()

  const updateMedicalNavigation = useCallback(
    async (key, value) => {
      let medical_navigation
      if (key === 'symptom') {
        const { symptom_id, symptom_name } = parseSymptom(value)
        medical_navigation = { symptom_id, symptom_name }
      } else {
        medical_navigation = { [key]: [...value] }
      }

      await onMedicalNavigationUpdate({
        id: TicketId,
        medical_navigation
      })
    },
    [TicketId, onMedicalNavigationUpdate]
  )

  const debouncedUpdateMedicalNavigation = useDebouncedFunction(
    updateMedicalNavigation,
    500
  )

  return (
    <>
      <Label required>Condition</Label>
      <FormItem
        name="symptom_name"
        rules={[
          {
            required: !ticket,
            message: 'Please select a condition'
          }
        ]}
      >
        <ConditionSelect
          onChange={
            ticket
              ? v => debouncedUpdateMedicalNavigation('symptom', v)
              : undefined
          }
          disabled={isClosed}
          shouldHighlight={shouldHighlight}
          isInProgress={isInProgress}
        />
      </FormItem>

      <Row gutter={16}>
        <Col span={12}>
          <Label>{`Member's Initial Care Choice`}</Label>
          <FormItem name="initial_care_choice_ids">
            <CareChoiceSelect
              onChange={
                ticket
                  ? v =>
                      debouncedUpdateMedicalNavigation(
                        'initial_care_choice_ids',
                        v
                      )
                  : undefined
              }
              dataTest="initialCareChoiceSelectDropdown"
              choiceType="initial"
            />
          </FormItem>
        </Col>
        <Col span={12}>
          <Label>Recommended Action</Label>
          <FormItem name="recommended_care_choice_ids">
            <CareChoiceSelect
              onChange={
                ticket
                  ? v =>
                      debouncedUpdateMedicalNavigation(
                        'recommended_care_choice_ids',
                        v
                      )
                  : undefined
              }
              dataTest="recommendedCareChoiceSelectDropdown"
              choiceType="recommended"
            />
          </FormItem>
        </Col>
      </Row>

      {ticket && (
        <Button
          onClick={toggleTriage}
          width="100%"
          margin="16px 0 0 0"
          height="40px"
          btnsize="custom"
        >
          <img
            src={clear_triage}
            alt="Open ClearTriage"
            style={{ maxHeight: 32 }}
          />
        </Button>
      )}
    </>
  )
}

MedicalNavigationFields.propTypes = {
  ticket: PropTypes.shape(Ticket.shape).isRequired,
  toggleTriage: PropTypes.func
}

export default MedicalNavigationFields
